import '../css/Homepage.scss';
import logo from '../images/logo100.png';
import { useHistory } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import apiUrl from '../assets/apiUrl';
import Header from './Header';

const Homepage = () => {
	const history = useHistory();
	const [fileCount, setFileCount] = useState<number>(0);
	useEffect(() => {
		fetch(`${apiUrl}/files/count`).then(async (res) =>
			setFileCount((await res.json()).file_count)
		);
	}, []);

	return (
		<div className="homepage">
			<Helmet>
				<title>Protonfile</title>
				<meta name="title" content="Protonfile" />
				<meta
					name="description"
					content="Store and share your files in the cloud"
				/>

				{/* Open Graph / Facebook */}
				<meta property="og:type" content="website" />
				<meta
					property="og:url"
					content="https://www.jz-software.com/web/protonfile/"
				/>
				<meta property="og:title" content="Protonfile" />
				<meta
					property="og:description"
					content="Store and share your files in the cloud."
				/>
				<meta
					property="og:image"
					content="https://www.jz-software.com/images/pidlfnzqjq.jpg"
				/>

				{/* Twitter */}
				<meta property="twitter:card" content="summary_large_image" />
				<meta
					property="twitter:url"
					content="https://www.jz-software.com/web/protonfile/"
				/>
				<meta property="twitter:title" content="Protonfile" />
				<meta
					property="twitter:description"
					content="Store and share your files in the cloud."
				/>
				<meta
					property="twitter:image"
					content="https://www.jz-software.com/images/pidlfnzqjq.jpg"
				/>
			</Helmet>
			<Header />
			<div className="intro">
				<div className="app-logo">
					<img
						src={logo}
						alt="app logo"
						onClick={() => {
							history.push('/login');
						}}
					/>
				</div>
				<div className="goals">
					<div className="text">
						<h1>
							<span style={{ color: '#42CAFF' }}>Store</span> and{' '}
							<span style={{ color: '#F6690C' }}>share</span>
							<br />
							your <span style={{ color: '#FE93A8' }}>files</span>
						</h1>
					</div>
				</div>
			</div>
			<div className="currently-stored">
				<div>
					<h1>{fileCount}</h1>
					<p>Files currently stored</p>
				</div>
				<i className="fas fa-project-diagram"></i>
			</div>
			<div className="create-account">
				<div>
					<h1>Create an account</h1>
					<p>
						To start using our app, please{' '}
						<span
							style={{ color: '#42CAFF', cursor: 'pointer' }}
							onClick={() => {
								history.push('/login');
							}}
						>
							create
						</span>{' '}
						an account. It's completely free.
					</p>
				</div>
			</div>
		</div>
	);
};

export default Homepage;
